module.exports = __webpack_public_path__ + "img/image (20).b9322740.jpg";